import { marker as bitfToTranslate } from '@biesbjerg/ngx-translate-extract-marker';
export enum EWorkOrderStatus {
  COMPLETED = 'COMPLETED',
  PARTIAL = 'PARTIAL',
}

const toTranslate = [
  bitfToTranslate('CONTRACTS.STATUS.COMPLETED'),
  bitfToTranslate('CONTRACTS.STATUS.PARTIAL'),
];
